module.exports = "/remote-dist/5283ca1cb4ac369eb576c1884b627ad5.png";